export interface PlayerScore {
    username: string
    score: number
}

export enum MainWindowStates {
    DEFAULT,
    ADD_TEMPLATE,
    EDIT_TEMPLATE,
    ADD_EVENT,
    EDIT_EVENT
}

export enum EventStates {
    UPCOMING,
    ACTIVE,
    WAITING,
    RESULTS,
    COMPLETED
}

export enum GameStates {
    ATTRACT,
    LOADING,
    SETUP,
    PLAYING,
    PAUSED,
    LIVE_PROMPT,
    LIVE_PAUSED,
    ANSWER,
    PAUSE_PROMPT,
    RESULTS,
    SCORES,
    END
}

export enum EventTypes {
    MULTIPLE_CHOICE = 'multiple',
    NUMBER_CURVE = 'numberCurve',
    PERCENTAGE_CURVE = 'percentageCurve',
    STRING_COMPARE = 'stringCompare',
    TIERED_ANSWERS = 'tieredAnswers',
    ORDER = 'order'
}

export interface Episode {
    title: string
    episode: string
    description?: string
    premiereDate: string
    releaseDate: string
    draft?: boolean
    introMusic?: {
        source: string
        url: string
        startTime: number
        endTime: number
    }
    promptMusic?: {
        source: string
        url: string
        startTime: number
        endTime: number
    }
    videoUrl: string
    videoPreview?: string
    startTime: number
    endTime: number
    totalPrompts: number
    events: Event[]
    series: Show
}

export interface TieredAnswer {
    acceptableAnswers?: Array<string | number>
    points: number
}

export interface Event {
    id: string
    startTime: number
    endTime?: number
    type: string
    pause?: boolean
    question?: string | JSX.Element
    stringQuestion?: string
    choices?: string[]
    answer?: string | number
    displayAnswer?: string
    points?: number
    stepAmount?: number
    stepDrop?: number
    resultsFor?: string
    acceptableAnswers?: Array<string | number>
    tieredAnswers?: TieredAnswer[]
    tieredResults?: number[]
    threshold?: number
    hideCaptions?: boolean
}

// const bdgEpisode: Episode = {
// mega man ranking episode https://www.youtube.com/watch?v=zum81Rwa2fw&ab_channel=Polygon
// }

// const dropoutEpisode: Episode = { like my coffee episode
//  https://www.youtube.com/watch?v=9EbvU8OZtqI&list=PLuKg-WhduhknsLFxK4K5YDtGVJuCf51kY&index=7&ab_channel=Dropout
// }

export interface Show {
    name: string
    description: string
    thumbnail: string
    creator: Creator
    draft?: boolean
    episodes: string[]
}

export interface MusicSource {
    source: 'mp3' | 'youtube' | 'current' | 'none'
    url: string
    startTime: number
    endTime: number
}

export interface Creator {
    name: string
    description: string
    channelIcon: string
    qrCode: string
    draft?: boolean
    platforms: {
        content?: {
            twitch?: string
            youtube?: string
            tiktok?: string
        }
        social?: {
            bsky?: string
            twitter?: string
            discord?: string
        }
        support?: {
            patreon?: string
            streamlabs?: string
            merch?: string
            website?: string
        }
    }
}

export interface LiveShow {
    events: LiveEvent[]
}

export interface LiveEvent extends Omit<Event, 'startTime' | 'endTime'> {
    status: EventStates
    startTime: number | null
    endTime: number | null
    resultTime: number | null
}

export interface LiveEventTemplate extends LiveEvent {
    templateName: string
}

export type Result = Record<
    string,
    {
        answer: string | number
        score: number
    }
>

export type PreviousEvents = Record<
    string, PreviousEvent
>

export interface PreviousEvent {
    event: Event | LiveEvent
    result: Result
}

export const ANSWER_TIME = 5
export const RESULTS_TIME = 5
export const SCORES_TIME = 10
export const TOTAL_TIME = ANSWER_TIME + RESULTS_TIME + SCORES_TIME
